import { FunctionComponent, ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from '@cbridge-utils/react-redux';
import { isAuthenticatedSelector } from '../../_selectors/isAuthenticated.selector';
import { AuthAction } from '../../auth.action';

export const AuthProtection: FunctionComponent<{ children?: ReactNode }> = ({ children }) => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(AuthAction.login());
    }
  }, [isAuthenticated, dispatch]);

  if (isAuthenticated) {
    return children;
  }

  return null;
};
